const refTypes = [
    "ABST",
    "ADVS",
    "AGGR",
    "ANCIENT",
    "ART",
    "BILL",
    "BLOG",
    "BOOK",
    "CASE",
    "CHAP",
    "CHART",
    "CLSWK",
    "COMP",
    "CONF",
    "CPAPER",
    "CTLG",
    "DATA",
    "DBASE",
    "DICT",
    "EBOOK",
    "ECHAP",
    "EDBOOK",
    "EJOUR",
    "WEB",
    "ENCYC",
    "EQUA",
    "FIGURE",
    "GEN",
    "GOVDOC",
    "GRANT",
    "HEAR",
    "ICOMM",
    "INPR",
    "JFULL",
    "JOUR",
    "LEGAL",
    "MANSCPT",
    "MAP",
    "MGZN",
    "MPCT",
    "MULTI",
    "MUSIC",
    "NEWS",
    "PAMP",
    "PAT",
    "PCOMM",
    "RPRT",
    "SER",
    "SLIDE",
    "SOUND",
    "STAND",
    "STAT",
    "THES",
    "UNBILL",
    "UNPB",
    "VIDEO",
];
export default refTypes;
